import { Languages } from "./constants/Languages";

// プロジェクトの言語IDとラベルのマッピングを定義する
let languageId2LabelMap = {};
for (let i = 0, len = Languages.length; i < len; i++) {
  const language = Languages[i];
  languageId2LabelMap[language.id] = language.label;
}

// プロジェクトの言語IDとACEeditorの言語モードのマッピングを定義する
let languageId2ModeMap = {};
for (let i = 0, len = Languages.length; i < len; i++) {
  const language = Languages[i];
  languageId2ModeMap[language.id] = language.mode;
}

export const ProgrammingLanguage = {
  getLabel: function (language: string) {
    let label: string;
    label = languageId2LabelMap[language];
    return label;
  },
  getAceMode: function (language: string) {
    let mode: string;
    mode = languageId2ModeMap[language];
    return mode;
  }
};
